export default {
  metadata: {},
  writeEvent(event, data) {
    if (!window.analytics) {
      return;
    }

    analytics.track(event, { ...this.metadata, ...data });
  },
};
